$(document).ready(() => {
  //  Mobile Navigation
  const navSlide = () => {
    const burger = document.querySelector('.burger');
    const nav = document.querySelector('.menu-items');
    const navLinks = document.querySelectorAll('.menu-items li');

    burger.addEventListener('click', () => {

      // Toggle Mobile Menu
      nav.classList.toggle('nav-active');

      //  Animate Links
      navLinks.forEach((link, index) => {
        if (link.style.animate) {
          link.style.animation = '';
        } else {
          link.style.animation = `navLinkFade 0.5s forwards ${index / 7 + 0.5}s`;
        }
      });

      // Burger Animation
      burger.classList.toggle('toggle');
    });
  };
  navSlide();

  //  Closes Mobile menu when menu item is clicked
  const mobileMenuLink = document.querySelectorAll('.menu-link');

  mobileMenuLink.forEach((link) => {
    link.addEventListener('click', () => {
      document.querySelector('.menu-items').classList.remove('nav-active');
    });
  });

  // // Glide Setting
  // const glide = new Glide(
  //   '#social-proof', {
  //     type: 'carousel',
  //     perView: 7,
  //     gap: 60,
  //     // focusAt: 'center',
  //     // autoplay: true,
  //     // animationDuration: 4000,
  //     breakpoints: {
  //       800: {
  //         perView: 3,
  //       },
  //       991: {
  //         perView: 4,
  //       },
  //       480: {
  //         perView: 2,
  //         // focusAt: 'center',
  //         autoplay: true,
  //         animationDuration: 4000,
  //       },
  //     },
  //   }
  // );
  // glide.mount();

  // const review = new Glide(
  //   '#reviews', {
  //     type: 'carousel',
  //     perView: 1,
  //     gap: 30,
  //   },
  // );

  // review.mount();

  //  Smooth Scroll
  const scroll = new SmoothScroll('a[href*="#"]', {
    offset: 60,
    speed: 600,
  });




  $(window).on('scroll', () => {
    if ($(window).width() > 768) {
      // Scroll of > 50px
      if ($(window).scrollTop() > 50) {
        // Changes Navigation Background Color On scroll of > 50px
        // Changes Navigation Logo to scroll Logo on scroll of > 50px

      } else {
        // Scroll of < 50px

      }
    }
  });

  // if ($(window).width() < 767) {}

  // // Countdown
  // // Set the date we're counting down to
  // const countDownDate = new Date('September 6, 2019 23:59:59').getTime();

  // // Update the count down every 1 second
  // const x = setInterval(() => {
  //   // Get todays date and time
  //   const now = new Date().getTime();

  //   // Find the distance between now and the count down date
  //   const distance = countDownDate - now;

  //   // Time calculations for days, hours, minutes and seconds
  //   const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  //   const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  //   const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  //   const seconds = Math.floor((distance % (1000 * 60)) / 1000);

  //   const time = {
  //     days,
  //     hours,
  //     minutes,
  //     seconds,
  //   };

  //   Object.keys(time).forEach((key) => {
  //     const number = time[key];

  //     if (number > 9) {
  //       const timeAsArray = number.toString().split('');
  //       $(`#${key} .numbers .number-area:eq(0)`).html(timeAsArray[0]);
  //       $(`#${key} .numbers .number-area:eq(1)`).html(timeAsArray[1]);
  //     } else {
  //       $(`#${key} .numbers .number-area:eq(0)`).html('0');
  //       $(`#${key} .numbers .number-area:eq(1)`).html(number);
  //     }
  //   });

  //   // If the count down is finished, write some text
  //   if (distance < 0) {
  //     clearInterval(x);
  //     document.getElementById('countdown').remove();
  //     document.getElementById('early-bird-text').remove();
  //     document.querySelector('.countdown-section').remove();
  //   }
  // }, 1000);


  // Wheel Click Modal
  $('button.btn-prime').on('mousedown', (e) => {
    if (e.which === 2) {
      e.preventDefault();
      e.stopPropagation();
      $(e.currentTarget).trigger('click');
    }
  });
});